/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ReportWrongCategoryItemDto = {
    /**
     * Classification the user marked as wrong
     */
    reportedClassification: string;
    /**
     * Correct classification selected by the user
     */
    correctClassification: ReportWrongCategoryItemDto.correctClassification;
}

export namespace ReportWrongCategoryItemDto {

    /**
     * Correct classification selected by the user
     */
    export enum correctClassification {
        MEDICAL_EMERGENCY = 'medical_emergency',
        ADVERSE_EVENT = 'adverse_event',
        STOP_PARTICIPATION = 'stop_participation',
        NO_RESPONSE = 'no_response',
        RESCHEDULING = 'rescheduling',
        BAD_PROFILE = 'bad_profile',
        CALLBACK = 'callback',
        COMPANY_INFO = 'company_info',
        STUDY_LOGISTIC = 'study_logistic',
        DATA_SUBJECT_REQUEST = 'data_subject_request',
        TECHNICAL_ISSUE = 'technical_issue',
        OTHER = 'other',
    }


}
